import axios from './http'

let BASE_URL = "/api/v2";
const BASE_URL_FILE = "/api/v3"; 

let api = {
    // #region --- 文件功能
    // 文件上传
    uploader(filePath){return BASE_URL_FILE+'/file/chunkUpload?filePath='+filePath},
    // 图片上传
    uploaderImage() { return BASE_URL_FILE+'/file/chunkAlipayImage'},
    // 文件删除
    deleteFile(data){return del(BASE_URL_FILE+'/file/deleteFile/'+data)},
    // 文件下载
    download(uid){return BASE_URL_FILE+'/file/download/'+uid},
    // word转PDF
    wordToPdfForDarkMark(data){return post(BASE_URL_FILE+`/file/chunkUpload/wordToPdfForDarkMark`,data)},
    // 根据Uid获取上传文件信息
    getFileByUid(data){return get(BASE_URL_FILE+'/file/'+data)},
    // 根据Uid获取预览pdf
    fileShowPdf(uid){return BASE_URL_FILE+`/file/showPdf/${uid}`},
    // 生成预览文件 
    createPreviewFile(data){return post(BASE_URL_FILE+`/file/convertTextToPdf`,data)},
    // 回显图片
    fileOutputStreamByUid(uid){ return BASE_URL_FILE + '/file/fileOutputStreamByUid/' + uid },
    // #endregion

    loginByTicket(para) {
        return axios.post(BASE_URL + '/sso/verifyTicket', para)
    },
    loginZh(para) {
        return axios.post(BASE_URL + '/log/submitZhLogin', para)
    },
    loginCa(para) {
        return axios.post(BASE_URL + '/log/submitCALogin', para)
    },
    getLoginEwm() {
        return axios.post(BASE_URL + '/log/toQrcodeView')
    },
    setSrcLogin(para) {
        return axios.post(BASE_URL + '/log/getDataByUuid', para)
    },
    ewmLogin(para) {
        return axios.post(BASE_URL + '/log/ewmLogin', para)
    },
    changeRyjs(para) {
        return axios.post(BASE_URL + '/log/changeRyjs', para)
    },
    //国家授时时间
    getGjsssj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/gjsssj', para)
    },
    //退出
    loginOut() {
        return axios.post(BASE_URL + '/log/logOut')
    },
    //终止开标
    saveStopKb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zzkb', para)
    },
    //开标页面列表
    getkbxmList(para) {
        return axios.post(BASE_URL + '/index', para)
    },
    //进入流程
    kbxm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/', para)
    },

    //提疑
    tyList(para) {
        return axios.post(BASE_URL + '/jc/tyhf/list', para)
    },
    saveTyhf(para) {
        return axios.post(BASE_URL + '/jc/tyhf/saveTyhf', para)
    },
    getkbxmlcTb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/getkbxmlcTb', para)
    },
    //摄像头
    getSxt(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zb', para)
    },
    getSxtAndLive(para) {
        return axios.get(BASE_URL + '/kb/kbxm/vod?bdId='+para)
    },
    startPushStream(para) {
        return axios.post(BASE_URL + '/kb/kbxm/startPushStream',para)
    },
    //临海摄像头
    getSxtNew(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zbNew', para)
    },
    //控制摄像头是否可看
    controlVideo(para) {
        return axios.post(BASE_URL + '/kb/kbxm/controlVideo', para)
    },
    //消息中心
    sendXx(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveXxzx', para)
    },
    getMsg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/xxzxList', para)
    },
    getMoreMsg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/xxzxMore', para)
    },
    //关闭开启发言
    kqfy(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kqfy', para)
    },
    //下一步按钮
    nextBtn(para) {
        return axios.post(BASE_URL + '/kb/kbxm/jrxyb', para)
    },
    //签到页面获取数据
    kbqdList(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kbqdList', para)
    },

    //开启签到按钮
    kqqdBtn(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kqkbqd', para)
    },
    //获取签到二维码
    getQdEwm() {
        return axios.post(BASE_URL + '/kb/kbqd/reqOneCR')
    },
    //验证签到二维码是否扫码
    setQdSrc(para) {
        return axios.post(BASE_URL + '/kb/kbqd/hqzsnrOne', para)
    },
    //ca签到
    caQd(para) {
        return axios.post(BASE_URL + '/kb/kbqd/tbdwqd', para)
    },
    //查询签到单位列表
    cxtbdwList(para) {
        return axios.post(BASE_URL + '/kb/kbqd/cxtbdwList', para)
    },
    ////////////////////////////投标人签到
    kbqdTbr(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kbqdTbr', para)
    },
    //宣布纪律
    kbhcjl(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kbhcjl', para)
    },
    saveKbhcjl(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveKbhcjl', para)
    },
    //有效性审查
    yxxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscList', para)
    },
    //保存审查结果
    saveYxxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveYxxscById', para)
    },
    //一键通过审查
    oneClickPassCensor(para) {
        return axios.post(BASE_URL + '/kb/kbxm/oneClickPassCensor', para)
    },
    saveScfs(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveYxxscScfs', para)
    },
    //招标人确认审查结果
    qdscjg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscQr', para)
    },
    //
    kpdjgbTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kpdjgbTbr', para)
    },
    ////////////////////////////投标人有效性审查
    yxxscTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscTbr', para)
    },
    //解密列表
    tbdwJmList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tbdwJmList', para)
    },
    //开启解密
    kqjm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kqjm', para)
    },
    //ca解密
    checkJm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/checkJm', para)
    },
    //获取解密二维码
    getJmEwm() {
        return axios.get(BASE_URL + '/kb/kbxm/reqOneCRJm')
    },
    //验证解密二维码
    setJmSrc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/hqzsnrOneJm', para)
    },
    //获取投保人解密二维码
    getTbrJmEwm() {
        return axios.get(BASE_URL + '/kb/kbxm/reqCR')
    },
    //验证投保人解密二维码
    setTbrJmSrc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/hqzsnrTbr', para)
    },
    //投标人发起申请补救
    sqbj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sqbj', para)
    },
    //获取申请补救列表
    getSqbjList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sqbjList', para)
    },
    //同意拒绝补救申请
    jssqbj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/jssqbj', para)
    },
    //保存提交补救文件
    saveBj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bjwj', para)
    },
    ////////////////////////////投标人解密
    tbdwJmTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tbdwJmTbr', para)
    },
    //唱标
    getCbData(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zdcbList', para)
    },
    getKbxmCscqnrForm(para) {
        return axios.post(BASE_URL + '/kbxm/cscqnr/getKbxmCscqnrForm', para)
    },
    //保存设置参数
    saveSzcs(para) {
        return axios.post(BASE_URL + '/kbxm/cscqnr/createKbxmCscqnr', para)
    },
    getPfjgTabs(para) {
        return axios.post(BASE_URL + '/kb/kbxm/gbpbjgpsx', para)
    },
    getPfjgList(para) {
        // return axios.post(BASE_URL + '/kb/kbxm/gbpbjgList', para)
        return axios.get('/api/v1/evaluation/open/get/evaluationResult', { params: para })
    },
    getEvalResult({nodeType, sequence, sectionId }) {
        return axios.get(`/api/v1/evaluation/open/export/evalResult/${nodeType}/${sequence}/${sectionId}`, {}, { responseType: 'blob' })
    },
    dcpsjgb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcpsjgb', para, { responseType: 'blob' })
    },
    ////////////////////////////投标人唱标
    zdcbTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zdcbTbr', para)
    },
    //开启报表
    getkbbbData(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kbbb', para)
    },
    //保存确认时间
    saveKqqrTime(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kqqr', para)
    },
    //生成报表
    scbb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/scbb', para)
    },
    //下载报表
    loadBb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/dcBb', para, { responseType: 'blob' })
    },
    getKpdjgb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kpdjgb', para)
    },
    loadKpdjgb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/downloadKqdjgb', para, { responseType: 'blob' })
    },
    createMoreReportForm(para) {
        return axios.post(BASE_URL + '/kb/kbjl/createMoreReportForm', para)
    },
    ////////////////////////////投标人确认
    kbqrTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kbqrTbr', para)
    },
    djqrTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/djqrTbr', para)
    },
    //符合性审查
    fhxscList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscList', para)
    },
    //一键审查
    fhxscYjps(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscYjps', para)
    },
    //获取投标单位列表
    getTbdwList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscSc', para)
    },
    //保存审查结果
    saveTbdw(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveFhxsc', para)
    },
    //下载结果
    dcFhxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcFhxsc', para, { responseType: 'blob' })
    },
    //中标候选人
    zbhxrList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zbhxrList', para)
    },
    //下载中标候选人
    dcZbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcZbhxr', para, { responseType: 'blob' })
    },
    //
    saveZbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveZbhxr', para)
    },
    //名录库编号
    zbhxrBh(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zbhxrBh', para)
    },
    //zygl
    getZygl(para) {
        return axios.post(BASE_URL + '/sys/account/resc', para)
    },
    saveZygl(para) {
        return axios.post(BASE_URL + '/sys/account/saveResc', para)
    },
    delZygl(para) {
        return axios.post(BASE_URL + '/sys/account/deleteResc', para)
    },
    //qxgl
    getQxgl(para) {
        return axios.post(BASE_URL + '/sys/account/auth', para)
    },
    //jsgl
    //yhgl
    //gsjggl
    getGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/list', para)
    },
    saveGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/saveGsjg', para)
    },
    delGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/deleteGsjg', para)
    },
    //lcpz
    getLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/lcdyList', para)
    },
    saveLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/saveLcdy', para)
    },
    delLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/deleteLcdy', para)
    },
    //lcgl
    getLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/lcglList', para)
    },
    saveLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/saveLcgl', para)
    },
    delLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/deleteLcgl', para)
    },
    enableOrdisableLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/qyOrJy', para)
    },
    getPbbf(para) {
        return axios.post(BASE_URL + '/lc/lcgl/getPbbf', para)
    },
    //mbgl
    getMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/list', para)
    },
    saveMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/saveMb', para)
    },
    delMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/deleteMb', para)
    },
    //kbsz
    getKbsz(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kbxmList', para)
    },
    saveKbsz(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveKbxm', para)
    },
    //dlgl
    getLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/roleLoginList', para)
    },
    saveLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/saveRoleLogin', para)
    },
    delLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/deleteRoleLogin', para)
    },
    // #region
    // 多次报价 新增api
    // 主持人多次报价界面展示
    dcbjquery(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/dcbjquery', { params: para })
    },
    // 主持人点击开启再次报价按钮时调
    kqzcbj(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/kqzcbj', { params: para })
    },
    // 招标代理点击公布历史报价时调用
    overridepublish(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/overridepublish', { params: para })
    },
    // 投标人多次报价界面展示
    tbrdcbjquery(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/tbrdcbjquery', { params: para })
    },
    // 投标人进入界面填写报价是点击确定按钮时调用
    bjjeoverride(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/bjjeoverride', para)
    },
    // 进入唱标页面是判断是否公开历史报价
    ispublish(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/ispublish', { params: para })
    },
    // 点击解密下一步
    savenext(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/savenext', para)
    },
    // 模糊查询
    querylike(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/querylike', { params: para })
    },
    // 多次查询 点击下一步
    savetbdw(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/savetbdw', { params: para })
    },
    // 查询保证金缴纳情况
    checkBzjzt(para) {
        return axios.post(BASE_URL + '/kb/kbxm/checkBzjzt', { params: para })
    },
    xzcsbb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/xzcsbb', { params: para })
    },
    downloadcsb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/downloadcsb', para, { responseType: 'blob' })
    },
    judgeType(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/judgeType', { params: para })
    },
    hqcqz(para) {
        return axios.get(BASE_URL + '/kbxm/cscqnr/hqcqz', { params: para })
    },
    tyhfwdlist(para) {
        return axios.post(BASE_URL + '/jc/tyhf/wdlist', para)
    },
    jszlist(para) {
        return axios.post(BASE_URL + '/jc/tyhf/jszlist', para)
    },
    filebefore(para) {
        return axios.post(BASE_URL + '/jc/tyhf/filebefore', para)
    },
    uploadtyfile(para) {
        return axios.post(BASE_URL + '/jc/tyhf/uploadtyfile', para)
    },
    toSign(para) {
        return axios.get(BASE_URL + '/jc/tyhf/toSign', { params: para })
    },
    pdfshow(para) {
        return axios.post(BASE_URL + '/jc/tyhf/pdfshow', para, { responseType: 'blob' })
    },
    delpdf(para) {
        return axios.post(BASE_URL + '/jc/tyhf/delpdf', para)
    },
    pdfview(para) {  // 未使用
        return axios.get(BASE_URL + '/jc/tyhf/pdfview/' + para, { responseType: 'blob' })
    },
    tyhfForm(para) {
        return axios.post(BASE_URL + '/jc/tyhf/tyhfForm', para)
    },
    // 获取验证码图片
    getGeneratePicture(str) {
        return `/api/v3/basic/captcha/generate?uniString=${str}`
    },

    // 获取询标列表数据
    inquiryRecord(para) {
        return axios.get(BASE_URL + '/kb/kbxb/inquiryRecord', { params: para })
    },
    // 获取询标数量
    replyNum() {
        return axios.get(BASE_URL + '/kb/kbxb/replyNum')
    },
    // 获取询标详情
    inquiryDetails(para) {
        return axios.get(BASE_URL + '/kb/kbxb/inquiryDetails', { params: para })
    },
    // 回复询标
    createInquiry(para) {
        return axios.get(BASE_URL + '/kb/kbxb/createInquiry', { params: para })
    },
    // 生成PDF
    createPdf(para) {
        return axios.get(BASE_URL + '/kb/kbxb/createPdf', { params: para })
    },
    // 获取签章信息
    signInfo(para) {
        return axios.get(BASE_URL + '/kb/kbxb/signInfo', { params: para })
    },

    kbjsxx(para) {
        return axios.get(BASE_URL + '/kb/kbxm/kbjsxx', { params: para })
    },

    // 获取快照
    evaluationProcess(para) {
        return axios.get('/api/v1/evaluation/open/get/evaluationProcess', { params: para })
    },
    getSnapshoot(para) {
        return axios.get('/api/v1/evaluation/open/get/snapshoot', { params: para })
    },

    // 唱标-校验是否填写开标参数
    checkCqz(para) {
        return axios.get(BASE_URL + '/kbxm/cscqnr/checkCqz', { params: para })
    },

    // #endregion

    getRedirectLoginUrl() {
        return axios.get(BASE_URL + '/sso/redirectLoginUrl')
    },

    // #region 竞争性比选 
    // 下一步
    bxNextBtn(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bxrxyb', para)
    },
    // 获取流程
    drjjxm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/drjjxm', para)
    },
    // 有效性审查--竞价
    kblbList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kblbList', para)
    },
    // 中标候选人列表
    tjzbhxrList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tjzbhxrList', para)
    },
    //获取所有需要抽取的参数
    listAllCs(para) {
        return axios.get(BASE_URL + '/kb/kbxmcs/listAllCs/'+ para)
    },
    //保存参数抽取内容
    saveCscqnr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveCscqnr', para)
    },
    //竞价公告查看
    noticeView(para){
        return axios.get(BASE_URL + '/file/noticeView',{responseType: 'blob'})
    },
    // 推荐中标候选人
    bczbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bczbhxr', para)
    },
    // 生成开标记录表
    sckbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sckbjlb', para)
    },
    // 开标记录表列表
    ckkbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/ckkbjlb', para)
    },
    // 现在开标记录表
    downloadKqdjgb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/downloadKqdjgb', para, { responseType: 'blob' })
    },
    //开启多次报价
    kqdcbj(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kqdcbj', para)
    },
    //关闭多次报价
    gbdcbj(para) {
        return axios.post(BASE_URL + '/kb/kbjl/gbdcbj', para)
    },
    //投标人报价
    tbdwxgdcbj(para) {
        return axios.post(BASE_URL + '/kb/kbjl/tbdwxgdcbj', para)
    },
    //投标人进入项目前先判断是否上传投标文件
    checkUploadBidFile(para) {
        return axios.post(BASE_URL + '/kb/kbxm/checkUploadBidFile', para)
    },
    getListInfoByKbxmId(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/getListInfoByKbxmId', para)
    },
    postInitializeZgsc(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/initializeZgsc', para)
    },
    getPbbfcsByKbxmId(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getPbbfcsByKbxmId', para)
    },
    saveComplianceReview(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/saveZgsc', para)
    },
    updateEntInfo(para) {
        return axios.post(BASE_URL + '/kb/kbxm/updateEntInfo', para)
    },
    //中标候选人
    getWinningCandidateList(para) {
        return axios.post(BASE_URL + '/kb/zbhxr/getListInfoByKbxmId', para)
    },
    saveWinningCandidate(para) {
        return axios.post(BASE_URL + '/kb/zbhxr/savezbhxr', para)
    },
    getWinningCandidateFlag(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getWinningCandidateFlag', para)
    },
    // 计算-新(根据列表接口中的newOrOld值判断调用新还是旧的接口)
    calculateCommercialBidScoreNew(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/getmethodByDjlcId', para)
    },
    getReportFormList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/getReportFormList', para)
    },
    //生成报表
    scKpytKbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/scKpytKbjlb', para)
    },
    //下载报表
    loadBb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/dcBb', para, { responseType: 'blob' })
    },
    pdfshow(para) {
        return axios.post(BASE_URL + '/jc/tyhf/pdfshow', para, { responseType: 'blob' })
    },
    //符合性审查下载
    tenderFileDownload(para) {
        return axios.get(BASE_URL + `/file/tenderFileDownload/${para}`, { responseType: 'blob' })
    },
    //符合性审查查询项目
    tenderFileList(para) {
        return axios.get(BASE_URL + `/file/tenderFileList/${para}`)
    },

    // #region 开评一体
    // 获取开评列表
    getKpytList: (para) => axios.post(BASE_URL + '/kb/kbxm/kpytList', para),
    // 设置投标候选人
    saveZbhxrKpyt: (para) => axios.post(BASE_URL + '/kb/kbxm/saveZbhxrKpyt', para),
    // 获取参数设置结果
    getCscqnrStr: (para) => axios.get(BASE_URL + '/kb/kbjl/cscqnrStr'),
    // 获取当前项目抽签状态
    getDrawButtonStatus: (para) => axios.get(BASE_URL + '/draw/getDrawButtonStatus', para),
    // 获取当前项目抽签类型
    getDrawTypeState: () => axios.get(BASE_URL + '/draw/getDrawType'),
    // 选择抽签方式
    postDrawType: (type) => axios.get(BASE_URL + `/draw/drawType/${type}`),
    // 线下抽签
    doDrawOffline: (para) => axios.post(BASE_URL + `/draw/doDrawOffline`, para),
    // #endregion
    // 专家手动触发结束解密
    endDecryptionPrematurely() {/*  */
        return axios.get(BASE_URL + `/kb/kbxm/endDecryptionPrematurely`)
    },
    // 获取抽签详情
    getDrawDetail() {
        return axios.get(BASE_URL + '/draw/getDrawDetail')
    },
    // 抽签操作
    doDraw(para) {
        return axios.post(BASE_URL + '/draw/doDraw', para)
    },
    // 打印抽签报表
    printDrawReport(){
        return axios.get(BASE_URL + '/draw/getDrawResultFile',{responseType: 'blob'})
    },
    // 是否签章
    checkHasQz(para) {
        return axios.get(BASE_URL + `/file/${para}`)
    },
    // 获取开标项目评标详情
    getProjectPbState: (para) => axios.get(BASE_URL + '/kb/kbxm/getPbzt', para),
    // 同步项目状态
    syncProjectState(para){
        return axios.post(BASE_URL + '/kb/kbxm/tbkbxmxx', para)
    },
    // #region
    // 获取中标让利率抽签按钮的状态
    getDrawRateButtonStatus: (para) => axios.get(BASE_URL + '/drawRandomNumber/getButtonStatus', para),
    // 获取中标让利率抽签详情
    getDrawRateDetail: (para) => axios.get(BASE_URL + '/drawRandomNumber/getDetail', para),
    // 抽取中标让利率抽
    doDrawRate: (para) => axios.post(BASE_URL + '/drawRandomNumber/doDraw', para),
    // 线下录入中标让利率
    doDrawRateOffline: (drawResult) => axios.get(BASE_URL + `/drawRandomNumber/doDrawOffline`, {
        params: drawResult
    }),
    // 选择抽签方式
    postDrawRateType: (isOffline) => axios.get(BASE_URL + `/drawRandomNumber/drawType/${isOffline}`),
    // 查看抽签方式
    getDrawRateType: () => axios.get(BASE_URL + `/drawRandomNumber/getDrawType`),
    // 查看抽签结果文件
    postDrawRateResultFile: () => axios.get(BASE_URL + `/drawRandomNumber/getDrawResultFile`, {responseType: 'blob'}),

    // #endregion
    // 是否需要显示保证金列
    getIsShowDeposit() {
        return axios.get(BASE_URL + '/kb/kbxm/isShowBail')
    },
    // 保存抽球记录
    postSaveCqRecord(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveCqjl', para)
    },
    // 查询抽球记录列表
    getCqRecordList(para) {
        return axios.get(BASE_URL + `/kb/kbxm/listDrawBall`,{ params: para })
    },
    // 查询中标候选人抽球记录列表
    getdrawRecordList(para) {
        return axios.get(BASE_URL + `/kb/kbxm/drawRecord`,{ params: para })
    },
}
export default api;
